import { type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { mailLabel, openMail, type MailKey } from "@/lib/email";

interface EmailLinkProps {
  mailKey: MailKey;
  subject?: string;
  body?: string;
  label?: ReactNode;
  locale?: string;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

/**
 * Renders a contact trigger instead of a plain-text address. The real
 * address is only assembled client-side on click.
 */
export function EmailLink({
  mailKey,
  subject,
  body,
  label,
  locale = "de",
  className,
  title,
  "aria-label": ariaLabel,
}: EmailLinkProps) {
  return (
    <button
      type="button"
      onClick={() => openMail(mailKey, subject, body)}
      className={cn("cursor-pointer text-left", className)}
      title={title}
      aria-label={ariaLabel ?? (typeof label === "string" ? label : mailLabel(locale))}
    >
      {label ?? mailLabel(locale)}
    </button>
  );
}

export default EmailLink;
